<template>
  <div class="app-message">
    {{ appTheme }}
    <cube-scroll
      v-if="messages && messages.length > 0"
      ref="scroll"
      :data="messages"
      :options="options"
      class="message-list"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp"
    >
      <template v-for="(item, index) in messages">
        <div :key="index" class="app-msg-box">
          <div class="app-msg-date">
            <div class="date-time">
              {{ item.msgDate }}
            </div>
          </div>
          <div class="app-msg-content">
            <div v-if="item.menuName && item.menuIcon" class="app-msg-title">
              <x-svg-icon :style="{ 'color': '#027AFF' }" class="app-icon-svg" :name="item.menuIcon"></x-svg-icon>
              <span class="app-msg-title_name">{{ item.menuName }}</span>
            </div>
            <!--  判断是否是邀请加入组织信息  -->
            <div v-if="item.msgContent[0] === '{' && item.msgContent[item.msgContent.length - 1] === '}'" class="app-msg-text">
              {{ JSON.parse(item.msgContent).userName }}邀请你加入「{{ JSON.parse(item.msgContent).tenantName }}」，同意或拒绝
            </div>
            <!-- eslint-disable-next-line -->
            <div v-else class="app-msg-text" v-html="item.msgContent">
            </div>
          </div>
        </div>
      </template>
    </cube-scroll>
    <template v-else>
      <div class="empty-box">
        <x-empty></x-empty>
      </div>
    </template>
  </div>
</template>

<script>
import apis from '@/api'
export default {
  data() {
    return {
      messages: [],
      page: 1,
      pageSize: 10,
      appTheme: ''
    }
  },
  computed: {
    options() {
      return {
        pullDownRefresh: {
          txt: this.$t('messageCenter.loadSuccess')
        },
        pullUpLoad: {
          txt: {
            more: '',
            noMore: '没有更多数据了'
          },
          visible: false
        },
        scrollbar: true
      }
    }
  },
  created() {
    this.page = 1
    this.messages = []
    this.appTheme = this.$route.query.appTheme
    this.init({
      page: this.page,
      pageSize: this.pageSize
    }, (data) => {
      this.messages = data.concat(this.messages)
      this.$nextTick(() => {
        const aTags = document.querySelectorAll('.app-msg-text a')
        aTags.forEach(a => {
          a.removeAttribute('href')
        })
      })
      this.readMessage()
    }, true)
  },
  methods: {
    init(data, callback, flag) {
      const request = { ...apis.MESSAGECENTER.QUERY_MESSAGE_BY_APP }
      request.params = {
        page: data.page,
        pageSize: data.pageSize,
        appId: this.$route.query.appId
      }
      if (flag) {
        this.$loading.show()
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            if (callback) {
              callback(resp.data, resp.total)
            }
            this.$loading.hide()
          },
          () => {
            this.$loading.hide()
          }
        )
        .asyncErrorCatch((error) => {
          this.$loading.hide()
        })
    },
    readMessage() {
      const request = {
        ...apis.MESSAGECENTER.READ_MESSAGE_BY_APP,
        params: {
          appId: this.$route.query.appId,
          tenantId: this.$route.query.tenantId
        }
      }
      this.$request(request)
    },
    onPullingDown() {
      this.page = 1
      this.init({
        page: this.page,
        pageSize: this.pageSize
      }, (data) => {
        this.messages = []
        this.$nextTick(() => {
          this.messages = data.concat(this.messages)
          const aTags = document.querySelectorAll('.app-msg-text a')
          aTags.forEach(a => {
            a.removeAttribute('href')
          })
        })
        this.$refs.scroll.forceUpdate()
      })
    },
    onPullingUp() {
      this.init({
        page: this.page + 1,
        pageSize: this.pageSize
      }, (data, total) => {
        if (this.messages.length < total) {
          this.messages = this.messages.concat(data)
          this.$nextTick(() => {
            const aTags = document.querySelectorAll('.app-msg-text a')
            aTags.forEach(a => {
              a.removeAttribute('href')
            })
          })
          if (data && data.length === this.pageSize) {
            this.page += 1
          }
        }
        this.$refs.scroll.forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss">
.app-message {
  background-color: $--app-body-bgColor;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  .app-msg-box {
    width: 100%;
    padding: 0 1.143rem;
    box-sizing: border-box;

    .app-msg-date {
      width: 100%;
      height: 3.714rem;
      display: flex;
      justify-content: center;
      align-items: center;

      .date-time {
        height: 1.429rem;
        padding: 0 0.857rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: $--app-light-color;
        border-radius: 0.714rem;
        color: $--app-notice-color;
        font-size: $--app-base-font-size;
        line-height: 1.429rem;
      }
    }

    .app-msg-content {
      // min-height: 6.142rem;
      background-color: $--app-light-color;
      padding: 1.143rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      .app-msg-title {
        display: flex;
        align-items: center;
        margin-bottom: 0.857rem;

        .app-msg-title_name {
          margin-left: 0.857rem;
          font-size: $--app-title-font-size;
        }

        .x-svg-icon {
          width: 1.428rem !important;
          height: 1.428rem !important;
          .svg-icon {
            width: 100% !important;
            height: 100% !important;
          }
        }
      }

      .app-msg-text {
        line-height: 1.571rem;
        a {
          color: $--app-base-font-color;
        }
      }
    }
  }

  .empty-box {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
